import React from "react";
import Outlets from "@templates/outlets/outlets-template";

export default () => (
	<Outlets pageContext={{ defaultType: "where-to-refill" }} />
);
